<template>
  <div>
    <h2>
      Manifest
    </h2>
    <el-form
      ref="form"
      v-loading="isSaving"
      :rules="rules"
      :model="formData"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Prefix Required"
            prop="prefixRequired"
          >
            <el-switch v-model="formData.prefixRequired" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Length"
            prop="length"
          >
            <el-input
              v-model="formData.length"
              type="number"
              placeholder="Length"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Prefix Def"
          >
            <el-input
              v-model="formData.prefixDef"
              placeholder="Prefix Def"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Minimum Def"
            prop="minDef"
          >
            <el-input
              v-model="formData.minDef"
              type="number"
              placeholder="Minimum Def"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Maximum Def"
            prop="maxDef"
          >
            <el-input
              v-model="formData.maxDef"
              type="number"
              placeholder="Maximum Def"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      rules: {
        length: [
          { required: true, message: 'Length is required.', trigger: ['blur'] }
        ],
        prefixDef: [
          { required: true, message: 'Prefix Def is required.', trigger: ['blur'] }
        ],
        minDef: [
          { required: true, message: 'Minimum Def is required.', trigger: ['blur'] }
        ],
        maxDef: [
          { required: true, message: 'Maximum Def is required.', trigger: ['blur'] }
        ]
      },
      isSaving: false
    }
  }
}
</script>
